module.exports = __webpack_public_path__ + "static/beer-peers-e014d2a852a60bb45ea9ed5f23d91483.jpg";